import React from 'react';
import useBannerAdStatic from './useBannerAdStatic/useBannerAdStatic';

import './BannerAdStatic.scss';
import BannerAdItem from './BannerAdItem';
import { useVisitId } from '../../hooks/useVisitId';
import useContextToken from '../../hooks/useContextToken';

// Helpers
import { getBuyflowLink } from '../../utils/helpers';

export type TDynamicAdOptions =
  | 'hboMax'
  | 'onDemandTV'
  | 'onDemandLaptop'
  | 'onDemandTablet'
  | 'appGrid'
  | 'spectrumMobile';

export interface IBannerAdStaticProps {
  version: 'howToWatch' | 'spectrumGoes' | 'dynamic';
  title?: string;
  dynamicOptions?: TDynamicAdOptions[];
  isGetStarted?: boolean;
}

const BannerAdStatic = ({
  version,
  title = '',
  dynamicOptions = [],
  isGetStarted,
}: IBannerAdStaticProps) => {
  const visitId = useVisitId();
  const { contextToken } = useContextToken();
  const buyflowLink = getBuyflowLink(
    'https://www.spectrum.com/premium-channels/hbo?cmp=sspp_sod_gm_hbomax_unauth_050523',
    'https://www.spectrum.net/upgrade/tv/add-channels/review?packageId=419291&cid=sspp_sod_gm_hbomax_auth_050523'
  );
  const ads: any = useBannerAdStatic(
    version,
    dynamicOptions,
    isGetStarted,
    visitId,
    buyflowLink,
    contextToken
  );

  const renderTitle = (
    title: string,
    version: 'howToWatch' | 'spectrumGoes' | 'dynamic'
  ) => {
    if (title) {
      return title;
    }
    return version === 'howToWatch'
      ? 'How to Watch'
      : 'Spectrum goes where you go';
  };

  return (
    <section className={`banner-ad-static ${version}`}>
      <div className="banner-ad-static__content">
        <h2 className="banner-ad-static__title">
          {renderTitle(title, version)}
        </h2>
        <ul className="banner-ad-static__ads">
          {ads.map(({ image, title, content, linkPath, videoUrl }) => (
            <li key={title} className="ad">
              <BannerAdItem
                image={image}
                title={title}
                content={content}
                linkPath={linkPath}
                videoUrl={videoUrl}
              />
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default BannerAdStatic;
